export default __webpack_public_path__ + "static/media/direction-fill.6a6e729c.svg";